// extracted by mini-css-extract-plugin
export var activeRegion = "styles-module--activeRegion--d9ba7";
export var card = "styles-module--card--f1bf8";
export var cardsWrapper = "styles-module--cardsWrapper--9bc78";
export var description = "styles-module--description--a630d";
export var mainTitle = "styles-module--mainTitle--439f3";
export var title = "styles-module--title--1ba15";
export var wrapper = "styles-module--wrapper--6b5f9";